import { useTranslation } from 'react-i18next'

import ErrorImage from 'shared/images/error_handler.png'
import { Button } from 'shared/ui/button'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

type Props = {
  text: string | undefined
}

export const DialogScanPassportError = ({ text }: Props) => {
  const { t } = useTranslation()

  const { closeDialog } = useDialogBottomSheet()

  return (
    <div className={s.dialog_scan_passport_error}>
      <ImageLazy
        src={ErrorImage}
        alt="error"
        className={s.image}
      />
      <div className={s.text}>
        <h3 className={s.title}>{t('scan_passport.scan_error')}</h3>

        <p className={s.description}>{text}</p>
      </div>

      <Button onClick={closeDialog}>
        <span className={s.text}>{t('close')}</span>
      </Button>
    </div>
  )
}
